export class YesNoOtherOptions {
    constructor() {
        return ['No', 'Yes', 'Pending', 'Unkown', 'Not Applicable']
    }
  }